import React, { useEffect, useState } from 'react';
import './DbBrowser.css';

const DbBrowser = ({ selectedConnection, packages = [], packagesError = null, packagesLoading = false, onPackageSelect = null }) => {
  const [search, setSearch] = useState('');

  // Debug logging
  useEffect(() => {
    if (selectedConnection) {
      console.log('DbBrowser - selectedConnection:', selectedConnection.name);
      console.log('DbBrowser - packages:', packages);
      console.log('DbBrowser - packages.length:', packages?.length);
      console.log('DbBrowser - packagesError:', packagesError);
      console.log('DbBrowser - packagesLoading:', packagesLoading);
    }
  }, [selectedConnection, packages, packagesError, packagesLoading]);

  const filteredPackages = (packages || []).filter((name) =>
    name.toLowerCase().includes((search || '').trim().toLowerCase())
  );

  return (
    <div className="db-browser">
      <h3 className="db-browser-title">DB Browser</h3>
      {!selectedConnection ? (
        <p className="db-browser-hint">Select a connection to view packages</p>
      ) : packagesLoading ? (
        <p className="db-browser-loading">Loading packages...</p>
      ) : packagesError ? (
        <div>
          <p className="db-browser-error">Error: {packagesError}</p>
          <p className="db-browser-hint" style={{ fontSize: '11px', marginTop: '4px' }}>
            Check browser console (F12) for details
          </p>
        </div>
      ) : !packages || packages.length === 0 ? (
        <div>
          <p className="db-browser-empty">No packages found</p>
          {selectedConnection && (
            <p className="db-browser-hint" style={{ fontSize: '11px', marginTop: '4px' }}>
              Connection: {selectedConnection.name}
            </p>
          )}
        </div>
      ) : (
        <div>
          <div className="db-browser-search-wrap">
            <input
              type="text"
              className="db-browser-search"
              placeholder="Search packages..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              aria-label="Search packages"
            />
          </div>
          <p className="db-browser-hint" style={{ fontSize: '11px', marginBottom: '8px' }}>
            {filteredPackages.length} of {packages.length} package{packages.length !== 1 ? 's' : ''}
            {search.trim() ? ' (filtered)' : ' found'}
          </p>
          <ul className="db-browser-list">
            {filteredPackages.map((name) => (
              <li
                key={name}
                className="db-browser-item"
                onClick={() => onPackageSelect && onPackageSelect(name)}
                title={name}
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DbBrowser;
